/**
 * The bar over a landing page - Figma `6440:35719`.
 *
 * The logo, and nothing else. The design draws a 72px bar containing a `Logo` instance;
 * the three menu-shaped frames beside it are **hidden** in the file, which is the design
 * saying it looked at a menu here and decided against one.
 *
 * That is the right answer for what a landing page is. It is an offer sent to a named
 * client, reached from a link in an e-mail and from nowhere else; a mega menu on it is an
 * invitation to leave the thing you were sent. The footer is still the site's, so a reader
 * who wants the company rather than the offer has somewhere to go.
 *
 * **The logo is not a link.** On every other page it goes to the homepage, and here that
 * would be the one navigation the design removed, wearing the brand mark.
 */
import { Logo } from './ui/Logo';

export default function LandingHeader() {
  return (
    <header className="border-b border-grey-300 bg-surface">
      <div className="weco-container flex items-center py-5">
        <Logo className="h-8 lg:h-[30px]" />
      </div>
    </header>
  );
}
